import TRADE_NICHE_PAGES from './tradeNicheLandings.json';
import { getTradesAreaBySlug } from './tradesAreasData';
import { getAreaBySlug } from './localAreasData';

export { TRADE_NICHE_PAGES };

export function nichePageKey(tradeSlug, areaSlug) {
  return `${String(tradeSlug).toLowerCase()}/${String(areaSlug).toLowerCase()}`;
}

export function findNichePage(tradeSlug, areaSlug) {
  const k = nichePageKey(tradeSlug, areaSlug);
  return TRADE_NICHE_PAGES.find((p) => nichePageKey(p.tradeSlug, p.areaSlug) === k);
}

export function resolveNicheArea(areaSlug) {
  if (!areaSlug || typeof areaSlug !== 'string') return null;
  const s = areaSlug.toLowerCase();
  const t = getTradesAreaBySlug(s);
  if (t) return { name: t.name, region: t.region };
  const l = getAreaBySlug(s);
  if (l) return { name: l.name, region: l.county };
  return null;
}
